import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/capacitor';
import * as SentrySibling from '@sentry/angular';
import { catchError } from 'rxjs/operators';
import { EMPTY, map, Observable, of } from 'rxjs';
import { rewriteFramesIntegration } from '@sentry/angular';
import { environment } from '../../environments/environment';
import { VersionService } from './version.service';

@Injectable()
export class SentryInitService {
  private readonly ignoredStatusCodes = new Set<number>([422]);

  constructor(private readonly versionService: VersionService) {
  }


  public initSentry(): Observable<void> {
    const dsn: string | undefined = environment.sentryDsn;
    if (dsn == null || dsn === '') {
      // eslint-disable-next-line no-console
      console.warn('Sentry не будет инициализирован так как переменная "sentryDsn" не установлена.');
      return EMPTY;
    }
    return this.versionService.getVersion().pipe(
      catchError(err => of(err)),
      map(result => {
        const release = result?.version;
        Sentry.init(
          {
            dsn,
            release,
            environment: environment.environmentName,
            beforeSend: (event, hint) => (this.shouldDrop(event, hint) ? null : event),
            integrations: [
              rewriteFramesIntegration(),
              // debugIntegration({
              //   stringify: true
              // })
            ]
          },
          SentrySibling.init
        );
        if (!release) {
          setTimeout(() => {
            throw new Error(`Невозможно получить версию релиза: ${result}`);
          });
        }
      })
    );
  }

  public setUserContextByEmail(email: string | null): void {
    if (email) {
      Sentry.setUser({
        email
      });
    } else {
      Sentry.setUser(null); // Сброс контекста пользователя
    }
  }

  private shouldDrop(event: unknown, hint?: unknown): boolean {
    const h = hint as { originalException?: { status?: number | string }; syntheticException?: { status?: number | string } } | undefined;
    const status = h?.originalException?.status ?? h?.syntheticException?.status;
    const n = typeof status === 'number' ? status : (typeof status === 'string' ? parseInt(status, 10) : undefined);
    return n != null && this.ignoredStatusCodes.has(n);
  }
}
